import type { NotificationPreferences } from '@central/api';
import { NotificationPreferencesCard, type NotificationCategory } from '@central/ui';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, notificationPrefsQuery } from '../api';

/** The signed-in user's own email notification switches. */
export function NotificationPrefs() {
  const qc = useQueryClient();
  const prefs = useQuery(notificationPrefsQuery);
  const save = useMutation({
    mutationFn: ({ key, on }: { key: NotificationCategory; on: boolean }) =>
      api.notificationPrefs.update({ [key]: on }),
    onSuccess: (p: NotificationPreferences) => qc.setQueryData(notificationPrefsQuery.queryKey, p),
  });
  return (
    <NotificationPreferencesCard
      prefs={prefs.data}
      loadError={prefs.error ?? undefined}
      saving={save.isPending ? save.variables?.key : undefined}
      saveError={save.error ?? undefined}
      onChange={(key, on) => save.mutate({ key, on })}
    />
  );
}
